import * as classes from "./world-loading.module.scss";
import TitleCL from "../../icons/TitleCL.svg";
import TitleFT from "../../icons/TitleFT.svg";
import TitleFF from "../../icons/TitleFF.svg";
import content from "../../content.json";
import { useContext, useEffect } from "react";
import { AppContext, World } from "../../contexts/AppContext";
import { loading } from "../../images";
import LoadProgress from "../LoadProgress/LoadProgress";
import PictureNiceLoader from "../PictureNiceLoader/PictureNiceLoader";
import { TransitionGroup, CSSTransition } from "react-transition-group";

const WorldLoading = () => {
  const { state } = useContext(AppContext);
  const { isWorldLoading, loadProgress, world } = state;

  const enumName = World[world];

  return (
    <TransitionGroup component={null}>
      {!isWorldLoading || world === null ? null : (
        <CSSTransition key={enumName} timeout={333}>
          <div className={classes.root}>
            <PictureNiceLoader
              className={classes.image}
              alt="A background image showing a preview of the world, including some of the looks"
              src={loading[world].src}
              sources={[
                {
                  srcSet: loading[world].srcSetLandscape.jpg,
                  type: "image/jpeg",
                  media: "(orientation: landscape)",
                },
                {
                  srcSet: loading[world].srcSetLandscape.webp,
                  type: "image/webp",
                  media: "(orientation: landscape)",
                },
                {
                  srcSet: loading[world].srcSetPortrait.jpg,
                  type: "image/jpeg",
                  media: "(orientation: portrait)",
                },
                {
                  srcSet: loading[world].srcSetPortrait.webp,
                  type: "image/webp",
                  media: "(orientation: portrait)",
                },
              ]}
              sizes="100vw"
            />
            <h2
              style={{
                position: "absolute",
                pointerEvents: "none",
                opacity: 0,
              }}
            >
              {content.worlds[enumName].name}
            </h2>
            {(() => {
              switch (world) {
                case World.CoralLagoon:
                  return <TitleCL className={classes.title} alt="" />;
                case World.FieldTrip:
                  return <TitleFT className={classes.title} alt="" />;
                case World.FungiForest:
                  return <TitleFF className={classes.title} alt="" />;
              }
            })()}
            <div className={classes["loader-wrapper"]}>
              <LoadProgress progress={loadProgress} />
              <p className={classes["loading-message"]}>
                {content.worlds[enumName].loadingMessage}
              </p>
            </div>
          </div>
        </CSSTransition>
      )}
    </TransitionGroup>
  );
};

export default WorldLoading;
